import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const detectionOptions = {
    // order and from where user language should be detected
    order: [
        'querystring',
        'navigator',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
    ],

    // keys or params to lookup language from
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,

    // cache user language on
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
};

i18n
    .use(HttpBackend)
    .use(detector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['de', 'en', 'pt', 'fr', 'ro'],
        detection: detectionOptions,
        backend: {
            loadPath: `${process.env.PUBLIC_URL || '/'}locales/{{lng}}/common.json`,
        },
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
